<template>
  <div class="pa-3">
    <v-row dense class="mb-1">
      <v-col cols="12" sm="6" md="3">
        <TarjetaKpi titulo="Piezas en el CSV" :valor="fmtNum(piezasCsv)" icono="mdi-file-delimited-outline"
          color="indigo" :cargando="cargando" />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <TarjetaKpi titulo="Piezas programadas" :valor="fmtNum(piezasProgramadas)" icono="mdi-calendar-check-outline"
          color="teal" :cargando="cargando" />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <TarjetaKpi titulo="Diferencia" :valor="fmtDif(diferencia)" icono="mdi-scale-balance"
          :color="diferencia === 0 ? 'blue-grey' : (diferencia > 0 ? 'blue' : 'deep-orange')"
          :cargando="cargando" :acento="diferencia !== 0" />
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <TarjetaKpi titulo="Órdenes con problemas" :valor="fmtNum(totalOrdenesConProblemas)"
          icono="mdi-alert-circle-outline" :color="totalErrores > 0 ? 'red' : 'amber darken-2'"
          :cargando="cargando" :acento="totalOrdenesConProblemas > 0" />
      </v-col>
    </v-row>

    <v-alert v-if="error" type="error" dense outlined class="mb-2">{{ error }}</v-alert>
    <v-alert v-else-if="mensaje" type="info" dense outlined class="mb-2">{{ mensaje }}</v-alert>

    <div class="d-flex align-center flex-wrap mb-2" style="gap: 8px;">
      <v-text-field v-model="busqueda" dense outlined hide-details clearable placeholder="Buscar ODT, máquina, molde…"
        prepend-inner-icon="mdi-magnify" style="max-width: 320px;" />

      <v-btn-toggle v-model="severidad" mandatory dense group class="ml-1">
        <v-btn small value="todas" text>Todas</v-btn>
        <v-btn small value="Error" text>
          <v-icon left x-small color="red">mdi-alert-circle</v-icon>Errores
        </v-btn>
        <v-btn small value="Advertencia" text>
          <v-icon left x-small color="amber darken-2">mdi-alert</v-icon>Advertencias
        </v-btn>
      </v-btn-toggle>

      <v-select v-model="tiposSel" :items="tiposDisponibles" multiple chips small-chips deletable-chips clearable
        dense outlined hide-details label="Tipo de problema" style="max-width: 340px;" />

      <v-spacer />
      <span class="caption grey--text">{{ fmtNum(itemsFiltrados.length) }} de {{ fmtNum(ordenes.length) }} órdenes</span>
    </div>

    <v-data-table :headers="headers" :items="itemsFiltrados" :search="busqueda" :loading="cargando" dense
      :items-per-page="25" :footer-props="{ 'items-per-page-options': [25, 50, 100, -1] }"
      :height="altoTabla(itemsFiltrados.length)" :fixed-header="!!altoTabla(itemsFiltrados.length)"
      class="tabla" loading-text="Cargando... Espere, Por Favor." :no-data-text="textoVacio"
      @click:row="abrirDetalle">
      <template v-slot:item.Clave="{ item }">
        <span class="font-weight-medium">{{ item.Clave }}</span>
      </template>

      <template v-slot:item.FechaCompromisoEntrega="{ item }">{{ fmtFecha(item.FechaCompromisoEntrega) }}</template>
      <template v-slot:item.PiezasCsv="{ item }">{{ fmtNum(item.PiezasCsv) }}</template>
      <template v-slot:item.PiezasProgramadas="{ item }">{{ fmtNum(item.PiezasProgramadas) }}</template>

      <template v-slot:item.Diferencia="{ item }">
        <span :class="claseDiferencia(item.Diferencia)">{{ fmtDif(item.Diferencia) }}</span>
      </template>

      <template v-slot:item.Estado="{ item }">
        <v-chip v-if="item.Estado === 'Ok'" x-small outlined color="green">
          <v-icon left x-small>mdi-check</v-icon>Sin problemas
        </v-chip>
        <v-chip v-else x-small :color="colorSeveridad(item.Estado)" dark @click.stop="abrirDetalle(item)">
          <v-icon left x-small>{{ item.Estado === 'Error' ? 'mdi-alert-circle' : 'mdi-alert' }}</v-icon>
          {{ resumenProblemas(item) }}
        </v-chip>
      </template>
    </v-data-table>

    <!-- ===================== DETALLE DE LOS PROBLEMAS ===================== -->
    <v-dialog v-model="dialog" max-width="720" scrollable>
      <v-card v-if="seleccionada">
        <v-card-title class="py-3">
          <v-icon left :color="colorSeveridad(seleccionada.Estado)">
            {{ seleccionada.Estado === 'Error' ? 'mdi-alert-circle' : 'mdi-alert' }}
          </v-icon>
          <span class="subtitle-1 font-weight-bold">{{ seleccionada.Clave }}</span>
          <v-chip x-small :color="colorSeveridad(seleccionada.Estado)" dark class="ml-2">
            {{ resumenProblemas(seleccionada) }}
          </v-chip>
          <v-spacer />
          <v-btn icon small @click="dialog = false"><v-icon small>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-divider />

        <v-card-text class="pt-3">
          <div class="d-flex flex-wrap mb-3" style="gap: 6px;">
            <v-chip small outlined>
              <v-icon left x-small>mdi-calendar</v-icon>{{ fmtFecha(seleccionada.FechaCompromisoEntrega) }}
            </v-chip>
            <v-chip v-if="seleccionada.Maquina" small outlined>
              <v-icon left x-small>mdi-robot-industrial</v-icon>{{ seleccionada.Maquina }}
            </v-chip>
            <v-chip v-if="seleccionada.Molde" small outlined>
              <v-icon left x-small>mdi-cube-outline</v-icon>{{ seleccionada.Molde }}
            </v-chip>
            <v-chip v-if="seleccionada.IdTrabajoOrden" small outlined>
              ODT {{ seleccionada.IdTrabajoOrden }}
            </v-chip>
          </div>

          <div class="comparacion mb-4">
            <div class="comparacion-celda">
              <div class="comparacion-lbl">Piezas en el CSV</div>
              <div class="comparacion-val">{{ fmtNum(seleccionada.PiezasCsv) }}</div>
            </div>
            <div class="comparacion-celda">
              <div class="comparacion-lbl">Programadas</div>
              <div class="comparacion-val">{{ fmtNum(seleccionada.PiezasProgramadas) }}</div>
            </div>
            <div class="comparacion-celda">
              <div class="comparacion-lbl">Diferencia</div>
              <div class="comparacion-val" :class="claseDiferencia(seleccionada.Diferencia)">
                {{ fmtDif(seleccionada.Diferencia) }}
              </div>
            </div>
          </div>

          <div v-for="(inc, i) in seleccionada.Incidencias" :key="i" class="incidencia"
            :class="[inc.Severidad === 'Error' ? 'incidencia--error' : 'incidencia--aviso', i > 0 ? 'mt-2' : '']">
            <v-icon :color="colorSeveridad(inc.Severidad)" small class="incidencia-icono">
              {{ inc.Severidad === 'Error' ? 'mdi-alert-circle' : 'mdi-alert' }}
            </v-icon>
            <div class="incidencia-cuerpo">
              <div class="d-flex align-center flex-wrap" style="gap: 6px;">
                <span class="font-weight-medium">{{ inc.Titulo }}</span>
                <v-chip v-if="inc.Referencia" x-small outlined>{{ inc.Referencia }}</v-chip>
              </div>
              <div class="caption grey--text text--darken-2 mt-1 detalle">{{ inc.Detalle }}</div>
            </div>
          </div>
        </v-card-text>

        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn text small @click="dialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import TarjetaKpi from './TarjetaKpi.vue'
import { prop, fmtNum, fmtDif, fmtFecha, altoTabla, mensajeError } from './utils'

// Etiqueta legible de cada tipo de hallazgo que devuelve el back.
const TIPOS = {
  Duplicada: 'Orden duplicada',
  NoCargada: 'No se cargó',
  RateEnCero: 'Rate en 0',
  SinFechaInicio: 'Sin fecha de arranque',
  SinHoraArranque: 'Sin hora de arranque',
  ErrorEnCarga: 'Error durante la carga',
  SinPlan: 'Cargada sin plan',
  BajaEnCsv: 'Baja (C) sin aplicar',
  SoloEnPlan: 'Falta en el CSV',
  MasPiezas: 'Piezas de más',
  MenosPiezas: 'Piezas de menos',
}

export default {
  name: 'CargaOtsComparativa',

  components: { TarjetaKpi },

  data() {
    return {
      cargando: false,
      error: '',
      mensaje: '',
      ordenes: [],
      piezasCsv: 0,
      piezasProgramadas: 0,
      diferencia: 0,
      totalOrdenesConProblemas: 0,
      totalErrores: 0,
      totalAdvertencias: 0,
      busqueda: '',
      severidad: 'todas',
      tiposSel: [],
      dialog: false,
      seleccionada: null,
    }
  },

  computed: {
    // Solo los tipos presentes en el resultado, para no ofrecer filtros vacíos.
    tiposDisponibles() {
      const vistos = new Set()
      this.ordenes.forEach((o) => (o.Incidencias || []).forEach((i) => vistos.add(i.Tipo)))
      return [...vistos].map((t) => ({ text: TIPOS[t] || t, value: t }))
    },

    itemsFiltrados() {
      return this.ordenes.filter((o) => {
        if (this.severidad !== 'todas' && o.Estado !== this.severidad) return false
        if (!this.tiposSel.length) return true
        return (o.Incidencias || []).some((i) => this.tiposSel.includes(i.Tipo))
      })
    },

    textoVacio() {
      if (this.severidad === 'Error') return 'Ninguna orden del periodo tiene errores.'
      if (this.severidad === 'Advertencia') return 'Ninguna orden del periodo tiene advertencias.'
      if (this.tiposSel.length) return 'Ninguna orden coincide con los tipos elegidos.'
      return 'No hay órdenes que comparar en este periodo.'
    },

    headers() {
      return [
        { text: 'ODT', value: 'Clave' },
        { text: 'Fecha compromiso', value: 'FechaCompromisoEntrega' },
        { text: 'Máquina', value: 'Maquina' },
        { text: 'Molde', value: 'Molde' },
        { text: 'Piezas CSV', value: 'PiezasCsv', align: 'end' },
        { text: 'Programadas', value: 'PiezasProgramadas', align: 'end' },
        { text: 'Diferencia', value: 'Diferencia', align: 'end' },
        { text: 'Estado', value: 'Estado', sortable: false },
      ]
    },
  },

  methods: {
    fmtNum,
    fmtDif,
    fmtFecha,
    altoTabla,

    claseDiferencia(n) {
      const v = Number(n || 0)
      if (v > 0) return 'blue--text font-weight-medium'
      if (v < 0) return 'deep-orange--text font-weight-medium'
      return ''
    },

    colorSeveridad(valor) {
      return valor === 'Error' ? 'red' : 'amber darken-2'
    },

    // "2 errores", "1 error · 3 advertencias", etc.
    resumenProblemas(item) {
      const partes = []
      if (item.TotalErrores) partes.push(`${item.TotalErrores} ${item.TotalErrores === 1 ? 'error' : 'errores'}`)
      if (item.TotalAdvertencias) {
        partes.push(`${item.TotalAdvertencias} ${item.TotalAdvertencias === 1 ? 'advertencia' : 'advertencias'}`)
      }
      return partes.join(' · ') || 'Sin problemas'
    },

    abrirDetalle(item) {
      if (!item || !item.Incidencias || !item.Incidencias.length) return
      this.seleccionada = item
      this.dialog = true
    },

    // Lo llama el contenedor con el rango vigente de los filtros.
    async cargar(inicio, fin) {
      this.cargando = true
      this.$emit('cargando', true)
      this.error = ''
      this.mensaje = ''
      try {
        const p = new URLSearchParams()
        if (inicio) p.append('inicio', inicio)
        if (fin) p.append('fin', fin)

        const { data } = await axios.get(`/CargaOts/Comparativa?${p.toString()}`)
        this.ordenes = (prop(data, 'ordenes') || []).map((o) => this.normalizar(o))
        this.piezasCsv = Number(prop(data, 'piezasCsv')) || 0
        this.piezasProgramadas = Number(prop(data, 'piezasProgramadas')) || 0
        this.diferencia = Number(prop(data, 'diferencia')) || 0
        this.totalOrdenesConProblemas = Number(prop(data, 'totalOrdenesConProblemas')) || 0
        this.totalErrores = Number(prop(data, 'totalErrores')) || 0
        this.totalAdvertencias = Number(prop(data, 'totalAdvertencias')) || 0
        this.mensaje = prop(data, 'mensaje') || ''
        this.$emit('auditoria', prop(data, 'auditoria') || null)
        this.$emit('carga-en-curso', prop(data, 'cargaEnCurso') || null)
        // Los tipos disponibles cambian con cada consulta: se descartan los que ya no existen.
        this.tiposSel = this.tiposSel.filter((t) => this.tiposDisponibles.some((d) => d.value === t))
      } catch (e) {
        this.ordenes = []
        this.piezasCsv = 0
        this.piezasProgramadas = 0
        this.diferencia = 0
        this.totalOrdenesConProblemas = 0
        this.totalErrores = 0
        this.totalAdvertencias = 0
        this.error = mensajeError(e, 'No se pudo generar la comparativa contra el plan.')
        // eslint-disable-next-line no-console
        console.error('Error generando la comparativa de la carga de OTs', e)
      } finally {
        this.cargando = false
        this.$emit('cargando', false)
      }
    },

    normalizar(o) {
      return {
        Clave: prop(o, 'clave'),
        ClavesCsv: prop(o, 'clavesCsv'),
        FechaCompromisoEntrega: prop(o, 'fechaCompromisoEntrega'),
        Maquina: prop(o, 'maquina'),
        Molde: prop(o, 'molde'),
        PiezasCsv: Number(prop(o, 'piezasCsv')) || 0,
        PiezasProgramadas: Number(prop(o, 'piezasProgramadas')) || 0,
        Diferencia: Number(prop(o, 'diferencia')) || 0,
        IdTrabajoOrden: prop(o, 'idTrabajoOrden'),
        Estado: prop(o, 'estado') || 'Ok',
        TotalErrores: Number(prop(o, 'totalErrores')) || 0,
        TotalAdvertencias: Number(prop(o, 'totalAdvertencias')) || 0,
        Incidencias: (prop(o, 'incidencias') || []).map((i) => ({
          Tipo: prop(i, 'tipo'),
          Severidad: prop(i, 'severidad'),
          Titulo: prop(i, 'titulo'),
          Detalle: prop(i, 'detalle'),
          Referencia: prop(i, 'referencia'),
        })),
      }
    },
  },
}
</script>

<style scoped>
.tabla >>> td,
.tabla >>> th {
  white-space: nowrap;
}

/* Las filas con problemas se sienten accionables: abren el diálogo. */
.tabla >>> tbody tr {
  cursor: pointer;
}

.comparacion {
  display: flex;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  overflow: hidden;
}

.comparacion-celda {
  flex: 1;
  padding: 8px 12px;
  text-align: center;
}

.comparacion-celda + .comparacion-celda {
  border-left: 1px solid rgba(0, 0, 0, 0.12);
}

.comparacion-lbl {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: rgba(0, 0, 0, 0.6);
}

.comparacion-val {
  font-size: 18px;
  font-weight: 600;
}

.detalle {
  white-space: normal;
  line-height: 1.4;
}

.incidencia {
  display: flex;
  gap: 10px;
  padding: 10px 12px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-left-width: 3px;
  border-radius: 4px;
}

.incidencia--error {
  border-left-color: #d64545;
}

.incidencia--aviso {
  border-left-color: #f0ac22;
}

.incidencia-icono {
  margin-top: 2px;
}

.incidencia-cuerpo {
  min-width: 0;
}
</style>
